import React from 'react';

import { cn } from 'components/lib/utils';
import Typography from 'components/Typography/Typography';

const AuthenticationLayout = ({
  main,
  footer,
  title,
  className
}: {
  main: React.ReactNode;
  footer?: React.ReactNode;
  title?: string;
  className?: string;
}) => {
  return (
    <div
      className={cn(
        'flex h-full min-h-screen xl:w-full xl:h-screen xl:p-4 gap-x-6 flex-col xl:flex-row justify-between',
        className
      )}
    >
      <div
        className={cn(
          'w-full xl:w-1/2 h-full flex flex-col justify-center items-center gap-y-10 xl:gap-y-0'
        )}
      >
        <div className="flex xl:mt-16 flex-col gap-y-2">
          <img
            className="h-auto w-screen object-contain block xl:hidden"
            src="./assets/images/self-serve-mobile-bg.png"
            alt="first-project-modal-bg"
          />
          <img
            className="w-[197px] object-cover mx-auto"
            src="./assets/images/full-logo-black.svg"
            alt="self-serve-bg"
          />
          {title && (
            <Typography className="text-p-xl font-semibold xl:font-normal text-base-sidebarForeground text-center">
              {title}
            </Typography>
          )}
        </div>
        <div className="px-4 max-w-[374px] xl:px-0 w-full xl:my-auto flex flex-col items-center">
          {main}
        </div>
        <div className="mb-16">{footer}</div>
      </div>
      <img
        className="xl:block xl:rounded-[10px] xl:w-1/2 hidden h-full object-cover"
        src="./assets/images/self-serve-sign-up-bg.png"
        alt="self-serve-bg"
      />
    </div>
  );
};

export default AuthenticationLayout;
